import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { QuoteService } from 'src/app/services/quote.service';
import * as L from 'leaflet';

@Component({
    selector: 'app-quote',
    templateUrl: './quote.component.html',
    styleUrls: ['./quote.component.css', '../../customerFace.css'],
    standalone: false
})
export class QuoteDetailsComponent implements OnInit {
  customerID: Number | null | any = null;
  quoteID: Number | null | any = null;
  quote: any = null;
  accessDenied = false;

  itineraryItems = [
    {
      day: 'Day 1',
      icon: 'flight_takeoff',
      title: 'London Heathrow Airport to Orlando International Airport',
      duration: '59 hours',
      airline: 'British Airways',
      cabinClass: 'Premium Economy',
      flightNumber: 'BA2313',
      checkInTime: '3h 0m Before Flight',
      baggageAllowance: '2 pc',
      departure: '07/01/2025 09:00',
      arrival: '09/01/2025 15:00',
    },
    {
      day: 'Day 2',
      icon: 'bed',
      title: 'Hilton Fort Lauderdale Marina',
      location: 'Fort Lauderdale - Hollywood Area - FL',
      checkIn: '07/01/2025 at 15:00',
      checkOut: '09/01/2025 at 12:00',
      nights: '2 Nights',
      board: 'Room Only',
      roomType: 'Double King Size Bed',
      overview: 'Renew your body and spirit at Hilton Fort Lauderdale Marina poised at the edge of the splendid Intracoastal Waterway...',
      image: 'https://tprofileapp.blob.core.windows.net/e7a688da-274a-428f-d9ad-08dcdc8b698f/52e3006e-6c0b-4d58-51d7-08dcdc8b6995/enquiries/56be03f5-fb17-48e2-b044-08dcf821ecf2/17378085673782293785800359549036.jpg'
    },
  ];


  whatsIncluded = [
    '9 night cruise',
    'Flight to Orlando International Airport',
    '2 nights in Home2 Suites by Hilton Port Arthur',
  ];

  totalPrice = 4600.0;

  panels = [
    { title: 'Overview', content: 'Details about the ship\'s overview...' },
    { title: 'Dining', content: 'Details about dining options...' },
    { title: 'Entertainment', content: 'Details about entertainment...' },
    { title: 'Health and Fitness', content: 'Details about health and fitness...' },
    { title: 'Kids and Teens', content: 'Details about activities for kids and teens...' },
    { title: 'Decks', content: 'Details about the decks...' },
    { title: 'Cabins & Fares', content: 'Details about cabins and fares...' },
  ];


  destinations = [
    {
      image: 'https://cdn.tprofile.com/content/Regions/9995093_florida/GALLERY_93ae7b_florida_1.jpg',
      title: 'Florida',
      description:
        'As well as being the Southernmost point in the USA, Florida has the longest coastline of any state, making it a paradise for travelers from across the globe. From thrill seekers at the most famous area for theme parks in the world, right to the serene beaches...',
      actions: [{ label: 'Ask a Question', type: 'cta' }],
    },
    {
      image: 'https://cdn.tprofile.com/content/Regions/957_Fort_Lauderdale/GALLERY_6a317b_fort-lauderdale_1.jpg',
      title: 'Fort Lauderdale',
      description: 'Willemstad is the capital and largest city of the island country of Curaçao, which is part of the Dutch Caribbean...',
      actions: [
        { label: 'Overview', type: 'info' },
        { label: 'Climate', type: 'info' },
      ],
    },
  ];

  feedbackType: string = '';
  comments: string = '';


  constructor(private route: ActivatedRoute, private quoteService: QuoteService) { }

  ngOnInit(): void {
    // Extract customerID and quoteID from the URL
    this.customerID = this.route.snapshot.paramMap.get('customerID');
    this.quoteID = this.route.snapshot.paramMap.get('quoteID');

    // Fetch quote details
    if (this.customerID && this.quoteID && this.customerID == 123 && this.quoteID == 131231) {
      ;
      this.quoteService
        .getQuoteDetails(this.customerID, this.quoteID)
        .then((quote: any) => {
          this.quote = quote;
        })
        .catch((error: any) => {
          console.error('Failed to fetch quote details:', error);
          this.accessDenied = true;
        });
    } else {
      this.accessDenied = true;
    }
  }

  ngAfterViewInit(): void {
    const map = L.map('map').setView([26.1224, -80.1373], 10); // Center at Fort Lauderdale

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(map);

    setTimeout(() => {
      map.invalidateSize(); // Ensure map resizes correctly
    }, 100);
  }

  editQuote(): void {
    console.log('Edit functionality here');
  }

  deleteQuote(): void {
    console.log('Delete functionality here');
  }

  submitFeedback() {
    if (this.feedbackType) {
      alert(`Feedback submitted: ${this.feedbackType}\nComments: ${this.comments}`);
    } else {
      alert('Please select a feedback option.');
    }
  }
}
